<template>
  <div class="container-fluid" :id="this.$route.name">
    <div class="row mb-4">
      <div class="col-12">
        <h4>مشخصات فردی</h4>
        <hr />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="LblfullName">نام کامل</small>
        <input type="text" class="form-control" v-model="userData.fullName" />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="LblperAge">سن </small>
        <input @keypress="$ValidNumber($event, 2, false)" type="text" class="form-control text-center dirltr" v-model="userData.perAge" />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="LblperTamas">شماره تماس ثابت </small>
        <input @keypress="$ValidNumber($event, 11, false)" type="text" class="form-control text-center dirltr" v-model="userData.perTamas" />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="LblperMobile">شماره موبایل </small>
        <input @keypress="$ValidNumber($event, 11, false)" type="text" class="form-control text-center dirltr" v-model="userData.perMobile" />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="LblperMobileWhatsUp">شماره واتس اپ </small>
        <input @keypress="$ValidNumber($event, 11, false)" type="text" class="form-control text-center dirltr" v-model="userData.perMobileWhatsUp" />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="Lblemail">ایمیل</small>
        <input type="email" class="form-control text-center dirltr" v-model="userData.email" />
      </div>
      <div class="col-lg-10 col-12 px-1"></div>
      <div class="col-lg-2 col-12 px-1">
        <button class="btn btn-success w-100 mt-3" @click="Editpersonel">اعمال تغییرات</button>
      </div>
      <div class="col-12 mt-5">
        <h4>تنظیمات اکانت</h4>
        <hr />
      </div>
      <!-- <div class="col-lg-2 col-6 px-1">
        <small id="Lblemail">نام کاربری</small>
        <input type="text" class="form-control text-center" v-model="Useranme" />
      </div>
      <div class="col-lg-1 col-6">
        <button @click="ChangeUsername" class="btn btn-success mt-4" style="white-space: nowrap; font-size: 12px">تغییر نام کاربری</button>
      </div> -->
      <!-- <div class="col-lg-1"></div> -->
      <div class="col-lg-2 col-6 px-1">
        <small id="Lblemail">رمز عبور قبلی</small>
        <input type="password" autocomplete="new-password" class="form-control text-center dirltr" v-model="oldPass" />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="Lblemail">رمز عبور جدید</small>
        <input type="password" autocomplete="new-password" class="form-control text-center dirltr required-Pass" v-model="newPass" />
      </div>
      <div class="col-lg-2 col-6 px-1">
        <small id="Lblemail">تکرار رمز عبور جدید</small>
        <input type="password" autocomplete="new-password" class="form-control text-center dirltr required-Pass" v-model="rptNewPass" />
      </div>
      <div class="col-lg-2 col-6">
        <button @click="ChangePass" class="btn btn-warning w-100 text-center mt-4" style="white-space: nowrap; font-size: 11px">تغییر رمز</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userData: {},
      Pss: '',
      Useranme: '',
      oldPass: '',
      newPass: '',
      rptNewPass: '',
    }
  },
  methods: {
    GetPersonelDetail() {
      var DataAxios = { Action: 'MyProfile/GetPersonelProfile', Method: 'POST', ArryfildValue: { Id: this.$session.get('UserInfo').tblUserId } }
      this.$PostData(DataAxios).then((result) => {
        if ((result.status = 'success')) {
          this.userData = result.tblPersonel[0]
          this.$store.state.OldDataForLog = JSON.stringify(result.tblPersonel[0])
          this.Pss = this.$DecryptionWithCryptoJS(result.pss)
          this.Useranme = result.userName
          // console.log("this.userData", this.userData);
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', result.msg, 'warning', 2000)
        }
      })
    },
    Editpersonel() {
      var DataAxiosEditP = { Method: 'POST', Action: 'MyProfile/Editpersonel', ArryfildValue: this.userData }
      DataAxiosEditP.ArryfildValue.tbluseId = this.$session.get('UserInfo').tblUserId
      DataAxiosEditP.ArryfildValue.tbluserGrpIdEdit = this.$session.get('UserInfo').tblUserGrpId
      this.$PostData(DataAxiosEditP)
        .then((result) => {
          if (result.status == 'success') {
            var temp = JSON.parse(JSON.stringify(this.$session.get('UserInfo')))
            temp.userNameDashBoard = this.userData.fullName
            temp.namFam = this.userData.fullName
            this.$session.set('UserInfo', temp)
            var temp = this.$session.get('UserInfo')
            this.$mySweetDefaultTost('عملیات موفق', 'عملیات با موفقیت انجام شد', 'success', 2000)
          }
        })
        .finally(() => {
          this.$store.state.renderProfile = false
          this.$nextTick(() => {
            this.$store.state.renderProfile = true
          })
        })
    },
    ChangeUsername() {
      var DataAxiosupdUsername = { Method: 'POST', Action: 'MyProfile/updUserName', ArryfildValue: { tbluserGrpIdEdit: this.$session.get('UserInfo').tblUserGrpId, tbluserId: this.$session.get('UserInfo').tblUserId, newusername: this.Useranme } }
      this.$PostData(DataAxiosupdUsername).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('عملیات موفق', 'نام کاربری  با موفقیت تغییر کرد', 'success', 2000)
        }
      })
    },
    ChangePass() {
      if(this.$ValidForm(this.$route.name) == false) return
      
      if (this.oldPass == this.Pss) {
        if (this.newPass == this.rptNewPass) {
          if (this.newPass.length > 4) {
            var DataAxiosupdPass = { Method: 'POST', Action: 'MyProfile/updPass', ArryfildValue: { tbluserGrpIdEdit: this.$session.get('UserInfo').tblUserGrpId, tbluserId: this.$session.get('UserInfo').tblUserId, newpass: this.newPass } }
            this.$PostData(DataAxiosupdPass).then((result) => {
              if (result.status == 'success') {
                this.$mySweetDefaultTost('عملیات موفق', 'نام کاربری  با موفقیت تغییر کرد', 'success', 2000)
              }
            })
          } else {
            this.$mySweetDefaultTost('خطا', 'رمز عبور حداقل 5 کارکتر دارد', 'error', 2000)
          }
        } else {
          this.$mySweetDefaultTost('خطا', 'رمز عبور جدید و تکرارش برابر نیستند', 'error', 2000)
        }
      } else {
        this.$mySweetDefaultTost('خطا', 'رمز عبور قدیمی به درستی وارد نشده است', 'error', 2000)
        return
      }
    },
  },
  created() {
    this.GetPersonelDetail()
  },
}
</script>
<style scoped></style>
